import React, { useState, useEffect } from "react";
import { ModalHeader } from "../../common/ModalHeader";
import { merchantList } from "../../../api/admin";
const MerchantsModal = ({ selectedData, handleClose, handleInitial }) => {
  const [data, setData] = useState({});
  const [remarks, setRemarks] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleView = async () => {
    setIsLoading(true);
    try {
      const _requestData = {
        flag: "view",
        merchant_code: selectedData?.code,
      };
      const response = await merchantList(_requestData);
      if (response.error === 0) {
        setData(response.data);
        setIsLoading(false);
      } else {
        closeModal();
      }
    } catch (error) {
      closeModal();
    }
  };

  useEffect(() => {
    handleView();
  }, []);

  const closeModal = () => {
    setData({});
    setIsLoading(false);
    handleClose();
  };

  return (
    <div className="fixed inset-0 bg-gray-700 bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-4 rounded-xl shadow-md w-500 max-w-3xl">
        <ModalHeader title={"Merchant Details"} onClick={closeModal} type={0} />
        <div>
          <div className="flex flex-wrap gap-4 justify-center">
            {!data?.merchant?.profile_img ? (
              <svg
                width="112"
                height="112"
                viewBox="0 0 112 112"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="112" height="112" rx="56" fill="#F3F4F6" />
                <path
                  d="M64.6 56.9998C63.1 55.1998 61.2 53.9498 59.1 53.2998C61.2 52.1998 62.6 49.9998 62.6 47.4498C62.6 43.7998 59.65 40.7998 55.95 40.7998C52.25 40.7998 49.35 43.8498 49.35 47.4998C49.35 49.9998 50.75 52.1998 52.85 53.3498C50.75 53.9998 48.9 55.2498 47.35 57.0498C45.15 59.6498 43.9 63.2498 43.85 67.1998C43.85 67.6498 44.1 68.0498 44.45 68.1998C45.8 68.8998 50.7 71.0998 55.95 71.0998C61.65 71.0998 66.2 68.8498 67.5 68.1498C67.85 67.9498 68.1 67.5498 68.1 67.1498C68.05 63.2498 66.8 59.6498 64.6 56.9998ZM56 43.1498C58.4 43.1498 60.4 45.0998 60.4 47.5498C60.4 49.9998 58.45 51.9498 56 51.9498C53.55 51.9498 51.6 49.9998 51.6 47.5498C51.6 45.0998 53.6 43.1498 56 43.1498ZM56 68.8998C51.85 68.8998 47.8 67.2998 46.15 66.4998C46.35 63.3498 47.35 60.5498 49.1 58.4498C50.9 56.2998 53.35 55.0998 56 55.0998C58.65 55.0998 61.1 56.2998 62.9 58.4498C64.65 60.4998 65.7 63.3498 65.85 66.4998C64.3 67.2998 60.5 68.8998 56 68.8998Z"
                  fill="#CED4DA"
                />
              </svg>
            ) : (
              <div className="w-28">
                <a
                  href={data?.merchant?.profile_img}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={data?.merchant?.profile_img}
                    alt="Profile"
                    className="h-28  w-full rounded-full"
                  />
                </a>
              </div>
            )}
          </div>

          <div className="flex flex-col gap-2 items-center align-center">
            <div className="mt-2 items-center ">
              <p className="text-lg font-semibold text-center select-all">
                {data?.merchant?.full_name}
              </p>
              <p className="select-all text-gray-400 text-center">
                {data?.merchant?.merchant_name}
              </p>
            </div>
          </div>

          <div className=" border-t w-full my-4"></div>
          <div className="flex flex-col justify-center">
            <div className="flex">
              <p className="w-40">Merchant Code</p>
              <div className="flex">
                <p className="mr-1">:</p>
                <p className=" select-all">{data?.merchant?.merchant_code}</p>
              </div>
            </div>
            <div className="flex">
              <p className="w-40">Nature of Business</p>
              <div className="flex">
                <p className="mr-1">:</p>
                <p>{data?.merchant?.description}</p>
              </div>
            </div>

            <div className="flex">
              <p className="w-40">Address</p>
              <div className="flex">
                <p className="mr-1">:</p>
                <p>{data?.merchant?.address}</p>
              </div>
            </div>

            <div className="flex">
              <p className="w-40">Language</p>
              <div className="flex">
                <p className="mr-1">:</p>
                <p>{data?.merchant?.language}</p>
              </div>
            </div>

            <div className="flex">
              <p className="w-40">Mobile Number</p>
              <div className="flex">
                <p className="mr-1">:</p>
                <p className=" select-all">{data?.merchant?.mobile_no}</p>
              </div>
            </div>

            <div className="flex">
              <p className="w-40">Email Address</p>
              <div className="flex">
                <p className="mr-1">:</p>
                <p className="select-all">{data?.merchant?.email_address}</p>
              </div>
            </div>

            <div className="flex">
              <p className="w-40">Date Created</p>
              <div className="flex">
                <p className="mr-1">:</p>
                <p className=" select-all">{data?.merchant?.date_created}</p>
              </div>
            </div>

            <div className=" border-t w-full my-4"></div>

            <div className="flex">
              <p className="w-40">Bank Name</p>
              <div className="flex">
                <p className="mr-1">:</p>
                <p className=" select-all">
                  {data?.merchant?.bank_info?.bank_name}
                </p>
              </div>
            </div>
            <div className="flex">
              <p className="w-40">Account Name</p>
              <div className="flex">
                <p className="mr-1">:</p>
                <p className=" select-all">
                  {data?.merchant?.bank_info?.account_name}
                </p>
              </div>
            </div>
            <div className="flex">
              <p className="w-40">Account Number</p>
              <div className="flex">
                <p className="mr-1">:</p>
                <p className=" select-all">
                  {data?.merchant?.bank_info?.account_no}
                </p>
              </div>
            </div>

            {!isLoading &&
              data?.merchant?.merchant_application.length !== 0 && (
                <div className="flex flex-col my-4">
                  <p className="text-gray-400 text-sm mb-2">
                    Supporting Documents
                  </p>
                  <div className="flex gap-4 overflow-x-auto pb-2">
                    {data?.merchant?.merchant_application?.map((doc, index) => {
                      return (
                        <div key={index} className="w-40 flex-shrink-0">
                          {doc.includes("pdf") ? (
                            <div>
                              <iframe
                                title="PDF Preview"
                                src={doc}
                                width="100%"
                                height="100%"
                                style={{ border: "none" }}
                              >
                                This browser does not support PDFs. Please
                                download the PDF to view it.
                              </iframe>
                              <span
                                className="mt-1 w-full text-primary-500 cursor-pointer text-center text-xs"
                                onClick={() => window.open(doc, "_blank")}
                              >
                                Download
                              </span>
                            </div>
                          ) : (
                            <a
                              href={doc}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src={doc}
                                alt={`Document ${index}`}
                                className="w-full rounded-lg border"
                              />
                            </a>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
          </div>
        </div>

        <div className="mt-2">
          <button
            onClick={() => closeModal()}
            className="w-full border p-3 rounded-lg hover:opacity-90"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MerchantsModal;
